import React from 'react'
import { Box, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import classes from './Footer_Admin.module.css'

import Paragraph from '../Paragraph/Paragraph';

const FooterAdmin = (props) => {
    return (
        <Box className={`${classes.footerOuter}`}>
            <div className={`${classes.divider}`}></div>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    {/* <Typography variant="h6" mt={2} component="h6" className={`${classes.text}`}>Need Assistance? You can contact on the following:</Typography> */}
                    <Paragraph fontSize={'20px'} margin={'10px 0 0 0'} textalign={'center'} text={"For further assistance please contact"} />
                </Grid>
                        <Grid item xs={12}>

                            <Typography mb={1} variant="p" component="p" sx={{ textAlign: 'center' }} className={`${classes.text}`}><a className={`${classes.link}`} href="tel:(08) 9362 2100 x 298">(08) 9362 2100 x 298</a></Typography>

                            <Typography mb={0} variant="p" component="p" sx={{ textAlign: 'center' }} className={`${classes.text}`}><a className={`${classes.link}`} href="mailto:bcconsultant7@aic.wa.edu.au">bcconsultant7@aic.wa.edu.au</a> </Typography>
                        </Grid>
            </Grid>
        </Box >
    )
}

export default FooterAdmin